<template>
  <v-navigation-drawer permanent clipped app width="200">
    <v-list dense>
      <v-list-item-group v-model="selectedItem" color="white">
        <v-list-item v-for="(item, i) in items" :key="'appDrawer' + i">
          <v-list-item-icon>
            <v-icon>mdi-{{ item.icon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{ item.text }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-item-group>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
export default {
  data: () => ({
    selectedItem: null,
    items: [
      { text: "Tenants", icon: "account", path: "/" },
      { text: "Instances", icon: "database-marker", path: "/instances" },
      { text: "Plans", icon: "text-box-multiple", path: "/plans" },
      {
        text: "Subscriptions",
        icon: "account-details",
        path: "/subscriptions",
      },
      { text: "Ledger", icon: "notebook-edit", path: "/ledger" },
      { text: "Invoices", icon: "invoice-text", path: "/invoices" },
      { text: "Quotas", icon: "ticket-confirmation", path: "/quotas" },
      { text: "Aggregate", icon: "chart-box", path: "/aggregate" },
      { text: "Analysis", icon: "chart-line", path: "/analysis" },
    ],
  }),

  watch: {
    path(v) {
      if (v != this.items[this.selectedItem]?.path) this.selectedItem = null;
    },

    selectedItem(index) {
      if (!this.items[index]) return;
      if (index > -1 && this.$route.path != this.items[index].path) {
        this.$router.push(this.items[index].path);
      }
    },
  },

  computed: {
    path() {
      return this.$route.path;
    },
  },
};
</script>
